import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, ref } from 'vue'
import { VueEditor } from 'vue2-editor'
import BKEditorConfig from '@/common/vue2Config'
import { Organization } from '@/modules/Organizations/types'
import BKCheckbox from '@/components/AppShared/BKCheckbox.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationSettingsGeneral',
  props: {
    org: null,
    isLoading: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  org: Organization
  isLoading: boolean
};

const instance = getCurrentInstance()





const mask = ref('##/##/####')
const editorConfig = ref(BKEditorConfig)

function updateGeneralInfo() {
  console.log(props.org)
  if (props.org.description) {
    props.org.description = instance?.proxy?.$sanitize(props.org.description)
  }
  emit('update')
}

return { __sfc: true,instance, props, emit, mask, editorConfig, updateGeneralInfo, VueEditor, BKCheckbox }
}

})